import React from "react";

const NoOfferFoundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M46.6667 16.6667L41.9526 11.9526C40.7024 10.7024 39.0067 10 37.2386 10H16.6667C12.9848 10 10 12.9848 10 16.6667V37.2386C10 39.0067 10.7024 40.7024 11.9526 41.9526L16.6667 46.6667M63.3333 33.3333L68.6193 38.6193C71.2228 41.2228 71.2228 45.4439 68.6193 48.0474L48.0474 68.6193C45.4439 71.2228 41.2228 71.2228 38.6193 68.6193L33.3333 63.3333M23.3333 23.3333H23.3667M70 10L10 70"
        stroke="url(#paint0_linear_528_30561)"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_528_30561"
          x1="10"
          y1="10"
          x2="70.5719"
          y2="70.5719"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoOfferFoundIcon;
